import React, { useCallback, useLayoutEffect } from 'react';
import { View, StyleSheet } from 'react-native';
import Spacer from 'design-system/Spacer';
import Button from 'design-system/Button';
import StatusBar from 'design-system/StatusBar';
import ScrollView from 'design-system/ScrollView';
import { AppView, CardView, Separator } from 'design-system';
import BottomPanel from 'design-system/BottomPanel';
import { SCREEN_BOTTOM_PADDING } from 'design-system/values';
import useColors from 'hooks/useColors';
import { useAppSelector } from 'store/hooks';
import { OnboardingFlow } from 'utils/types/navigation';
import AutomatedSavingsCard from 'features/pots/components/AutomatedSavingsCard';
import useNavigateToWithdrawScreen from 'features/wealth/hooks/useNavigateToWithdrawScreen';
import HelpScreenButton from 'features/help/components/HelpScreenButton';
import RowAmount from '../components/RowAmount';
import { useAccountScreenData } from '../hooks';
import OpenPotCTA from '../components/OpenPotCTA';
import BalanceView from '../components/BalanceView';
export const strings = {
    balanceTitle: 'Available to invest',
    reservedCash: 'Reserved cash',
    linkedBankAccountTitle: 'Linked bank account',
    topUp: 'Deposit',
    withdraw: 'Withdraw',
    topUpModalTitle: 'Quick Top Up',
    tooltipTitle: 'How is it estimated?',
    tooltipTextBalance: 'Money available to invest at any time. Orders that still need to settle might affect this.',
    tooltipTextReserved: 'Money reserved for your queued buy orders. If you want to, you can cancel these queued orders to add this money back into your available cash.',
    errorTitle: 'The\xa0payment\xa0didn’t\xa0go through. Please\xa0try\xa0again.',
};
const AccountScreen = ({ navigation }) => {
    const colors = useColors();
    const scrambled = useAppSelector((store) => store.utils.scrambled);
    useLayoutEffect(() => {
        navigation.setOptions({
            title: 'Account',
            headerTintColor: colors.text.primary,
            headerRight: () => <HelpScreenButton />,
        });
    }, [colors.text.primary]);
    const [tradingAccount] = useAccountScreenData();
    const onTopUpPress = useCallback(() => {
        if (scrambled)
            return;
        navigation.navigate('InvestSelectAccountToTopup');
    }, [scrambled, navigation]);
    const onWithdraw = useNavigateToWithdrawScreen(OnboardingFlow.Invest);
    return (<AppView withFrame={false}>
      <StatusBar barStyle="dark-content" animated/>
      <ScrollView secondary contentContainerStyle={styles.contentContainerStyles}>
        {tradingAccount ? (<CardView noMarginTop>
            {tradingAccount?.availableToInvest ? (<BalanceView title={strings.balanceTitle} amount={tradingAccount.availableToInvest} tooltipTitle={strings.tooltipTitle} tooltipText={strings.tooltipTextBalance}/>) : null}
            <Separator />
            {!!tradingAccount.cashReserved && (<RowAmount showCents bold noBottomLine altTooltipSpacing title={strings.reservedCash} amount={tradingAccount.cashReserved} tooltipTitle={strings.tooltipTitle} tooltipText={strings.tooltipTextReserved}/>)}
          </CardView>) : null}
        <OpenPotCTA />
        <AutomatedSavingsCard noMarginBottom/>
      </ScrollView>
      <BottomPanel>
        <View style={styles.buttonContainer}>
          {!!tradingAccount?.cashWithdrawable && (<>
              <Button brandReversed flex title={strings.withdraw} onPress={onWithdraw}/>
              <Spacer w={8}/>
            </>)}
          <Button brand flex title={strings.topUp} onPress={onTopUpPress}/>
        </View>
      </BottomPanel>
    </AppView>);
};
const styles = StyleSheet.create({
    buttonContainer: {
        flexDirection: 'row',
    },
    contentContainerStyles: {
        paddingBottom: SCREEN_BOTTOM_PADDING,
    },
});
export default AccountScreen;
